// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-pdf__Page__canvas {
	border-radius: 8px;
	border: 1px solid #eee;
}

.ph-style {
	background: #fafafa;
	border-radius: 6px;
	padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/contract-editor/pdf-block-dnd/pdf-page/pdf-page.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;AACb","sourcesContent":[".react-pdf__Page__canvas {\n\tborder-radius: 8px;\n\tborder: 1px solid #eee;\n}\n\n.ph-style {\n\tbackground: #fafafa;\n\tborder-radius: 6px;\n\tpadding: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
